import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EmailSeries from './icon-email-series.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EmailSeries {...validProps} />;
}
SvgComponent.iconName = 'emailSeries';

export const EmailSeriesIcon = svgIconWrapper(SvgComponent);
